import { localStorage } from "./storage"

export interface StoredUser {
  firstName?: string
}

export const storedUser = (): StoredUser | null => {
  try {
    const user = JSON.parse(localStorage?.getItem("user") || "{}")

    if (typeof user === "object" && user !== null && Object.hasOwn(user, "firstName")) {
      return user as StoredUser
    }

    return null
  } catch (_) {
    return null
  }
}

export const isSignedIn = (): boolean => storedUser() !== null
